<template>

    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon large left color="white">mdi-account-wrench</v-icon>
              <span class="headline font-weight-bold">Alterar Serviços do Técnico</span>
            </v-card-title>

            <v-divider class="mb-4"></v-divider>

            <v-card-text>
              <v-text-field
                v-model="nomeMedico"
                label="Nome do Técnico"
                disabled
                outlined
                prepend-icon="mdi-account"
                class="mb-6"
              ></v-text-field>

              <v-form v-model="valid" ref="form" @submit.prevent="cadastrarTecnicoServico">
                <v-autocomplete
                  v-model="servicosEscolhidos"
                  :items="listaServicosUnidade"
                  item-value="idServico"
                  item-text="nomeEspecialidade"
                  label="Serviços"
                  multiple
                  chips
                  outlined
                  :rules="servicosRules"
                  no-data-text="Nenhum serviço disponível"
                  prepend-icon="mdi-briefcase-search"
                  class="mb-6"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3" small color="primary" class="white--text">
                      {{ item.nomeEspecialidade }}
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">
                      (+{{ servicosEscolhidos.length - 3 }} outros)
                    </span>
                  </template>
                </v-autocomplete>

                <v-alert
                  v-model="erroEditar"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Erro ao atualizar serviços!
                </v-alert>

                <v-alert
                  v-model="erroServicosIguais"
                  color="warning"
                  icon="mdi-alert"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Nenhuma alteração foi detectada nos serviços
                </v-alert>

                <v-alert
                  v-model="sucessoEditar"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Serviços atualizados com sucesso!
                </v-alert>

                <v-checkbox
                  v-model="checkbox"
                  :rules="[v => !!v || 'Você deve concordar para continuar']"
                  label="Confirmo que as alterações estão corretas"
                  required
                  class="mt-0"
                ></v-checkbox>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    rounded
                    depressed
                    type="submit"
                    :disabled="!valid"
                    :loading="loading"
                    class="px-6"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar Alterações
                  </v-btn>

                  <v-btn
                    to="/listaTecnicosUnidade"
                    large
                    outlined
                    rounded
                    color="grey darken-1"
                    class="ml-2"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'EditarServicosTecnico',
  data () {
    return {
      loading: false,
      valid: false,
      checkbox: false,
      erroEditar: false,
      erroServicosIguais: false,
      sucessoEditar: false,
      idMedico: '',
      nomeMedico: '',
      servicosEscolhidos: [],
      servicosInicial: [],
      listaServicosUnidade: [],
      servicosRules: [
        v => (v && v.length > 0) || 'O técnico deve possuir pelo menos um serviço'
      ]
    }
  },
  async mounted () {
    if (!this.$route.params.item) {
      this.$router.push('/listaTecnicosUnidade')
      return
    }

    this.user = this.$store.getters.usuario
    this.idMedico = this.$route.params.item.idMedico
    this.nomeMedico = this.$route.params.item.nome

    await Promise.all([
      this.retornarServicosUnidade(),
      this.retornarServicosMedico()
    ])
  },
  methods: {
    async retornarServicosUnidade () {
      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarServicosUnidade(this.user.idUnidade)
        this.listaServicosUnidade = response.data
      } catch (error) {
        console.error('Erro ao buscar serviços da unidade:', error)
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar os serviços da unidade'
        })
      }
    },

    async retornarServicosMedico () {
      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarServicosMedico(this.idMedico)
        this.servicosEscolhidos = response.data.map(s => s.idServico)
        this.servicosInicial = [...this.servicosEscolhidos]
      } catch (error) {
        console.error('Erro ao buscar serviços do técnico:', error)
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar os serviços do técnico'
        })
      }
    },

    async cadastrarTecnicoServico () {
      if (!this.$refs.form.validate()) return

      // Verifica se houve alteração nos serviços
      const servicosAtuais = new Set(this.servicosEscolhidos)
      const servicosIniciais = new Set(this.servicosInicial)

      if (servicosAtuais.size === servicosIniciais.size &&
          [...servicosAtuais].every(s => servicosIniciais.has(s))) {
        this.erroServicosIguais = true
        return
      }

      this.loading = true
      this.erroEditar = false
      this.erroServicosIguais = false
      this.sucessoEditar = false

      try {
        // Prepara os dados para envio
        const servicosParaAdicionar = this.servicosEscolhidos
          .filter(id => !this.servicosInicial.includes(id))
          .map(id => ({ idServico: id, status: 1 }))

        const servicosParaRemover = this.servicosInicial
          .filter(id => !this.servicosEscolhidos.includes(id))
          .map(id => ({ idServico: id, status: 0 }))

        const servicosAux = [...servicosParaAdicionar, ...servicosParaRemover]

        const response = await administradorUnidadeService.administradorUnidade
          .cadastraTecnicoServico(this.idMedico, servicosAux)

        if (response.data === 'erro') {
          this.erroEditar = true
        } else if (response.data === true) {
          this.sucessoEditar = true
          setTimeout(() => {
            this.$router.push('/listaTecnicosUnidade')
          }, 1500)
        }
      } catch (error) {
        console.error('Erro ao atualizar serviços:', error)
        this.erroEditar = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-chip {
  margin: 2px;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>
